import { createDriver } from '@redux-requests/axios'
import { handleRequests } from '@redux-requests/core'
import { AxiosError } from 'axios'
import { LineChartData2 } from '../../components/molecules/LineChart/LineChart2'
import axios from '../axios'
import { GET_USER_BY_UID, GET_WHITELIST, SET_USER_SETTINGS } from './auth/auth.actions'
import { User } from './auth/auth.types'
import {
  FETCH_ALL_PRODUCT_DATA,
  FETCH_ALL_PRODUCT_DATA_BY_USER,
  FETCH_MOVING_AVERAGES,
  FETCH_USER_AVERAGES,
  FETCH_GOVSTATS,
  FETCH_DETAILED_DATA,
  FETCH_DETAILED_DATA_NEW,
  FETCH_SUMMARY_DATA,
  FETCH_LINECHART_DATA,
  POST_PDF,
  DELETE_DOCUMENT,
  FETCH_DOCUMENT,
  FETCH_METADATA,
  FETCH_DOCUMENT2,
  DOCUMENT_RECEIVED,
  CREATE_DOCUMENT,
  UPDATE_DOCUMENT,
  ADD_WHITELIST_ITEM,
  DELETE_WHITELIST_ITEM,
  FETCH_DISCARDED,
  SET_CUSTOM_FILTER,
  GET_CUSTOM_FILTERS,
  DELETE_CUSTOM_FILTER,
  FETCH_ALL_DISCARDED,
  FETCH_DISCARDED_WITH_RANGE,
  FETCH_NET_PRICE_CHART_DATA,
  FETCH_DIESEL_DATA,
} from './products/product.actions'
import {
  ProductData,
  MovingAverage,
  UserAverage,
  GovStat,
  DetailedData,
  SummarySorted,
  LineChartData,
  Metadata,
  OatsSettlement,
  RapsSettlement,
  FoderInvoice,
  Filter,
  NetPriceData,
} from './products/product.types'

export type RequestsStateQueries = {
  [FETCH_DOCUMENT]: RequestQuery<ProductData | OatsSettlement | RapsSettlement | FoderInvoice>
  [FETCH_DOCUMENT2]: RequestQuery<ProductData>
  [FETCH_ALL_PRODUCT_DATA]: RequestQuery<ProductData[]>
  [FETCH_ALL_PRODUCT_DATA_BY_USER]: RequestQuery<ProductData[]>
  [FETCH_MOVING_AVERAGES]: RequestQuery<MovingAverage[]>
  [FETCH_USER_AVERAGES]: RequestQuery<UserAverage[]>
  [FETCH_GOVSTATS]: RequestQuery<GovStat[]>
  [FETCH_DETAILED_DATA]: RequestQuery<DetailedData[]>
  [FETCH_DETAILED_DATA_NEW]: RequestQuery<DetailedData[]>
  [FETCH_SUMMARY_DATA]: RequestQuery<SummarySorted[]>
  [FETCH_LINECHART_DATA]: RequestQuery<LineChartData>
  [GET_USER_BY_UID]: RequestQuery<User>
  [POST_PDF]: RequestQuery<string>
  [DELETE_DOCUMENT]: RequestQuery<string>
  [FETCH_METADATA]: RequestQuery<Metadata>
  [DOCUMENT_RECEIVED]: RequestQuery<ProductData>
  [CREATE_DOCUMENT]: RequestQuery<any>
  [UPDATE_DOCUMENT]: RequestQuery<any>
  [GET_WHITELIST]: RequestQuery<any>
  [ADD_WHITELIST_ITEM]: RequestQuery<any>
  [DELETE_WHITELIST_ITEM]: RequestQuery<any>
  [SET_USER_SETTINGS]: RequestQuery<any>
  [FETCH_DISCARDED]: RequestQuery<LineChartData2[]>
  [SET_CUSTOM_FILTER]: RequestQuery<Filter>
  [GET_CUSTOM_FILTERS]: RequestQuery<Filter[]>
  [DELETE_CUSTOM_FILTER]: RequestQuery<Filter>
  [FETCH_ALL_DISCARDED]: RequestQuery<any[]>
  [FETCH_DISCARDED_WITH_RANGE]: RequestQuery<any[]>
  [FETCH_NET_PRICE_CHART_DATA]: RequestQuery<any[]>
  [FETCH_DIESEL_DATA]: RequestQuery<any[]>
}

export type RequestQuery<T> = {
  data: T
  loading: boolean
  error: AxiosError
  pristine: boolean
}

export type RequestsState = {
  queries: RequestsStateQueries
  mutations: {}
  cache: {}
  requestsKeys: {}
  normalizedData: {}
}

export const { requestsReducer, requestsMiddleware } = handleRequests({
  driver: createDriver(axios),
})
